import { render, staticRenderFns } from "./gateway-frame.vue?vue&type=template&id=ccb1727e&scoped=true&"
import script from "./gateway-frame.vue?vue&type=script&lang=js&"
export * from "./gateway-frame.vue?vue&type=script&lang=js&"
import style0 from "./gateway-frame.vue?vue&type=style&index=0&id=ccb1727e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb1727e",
  null
  
)

export default component.exports